module.exports = __webpack_public_path__ + "img/food_tests.6a3dafcb.png";